module.exports = __webpack_public_path__ + "static/media/Sketches-1.33a173be.jpg";